module.exports = __webpack_public_path__ + "static/Busante_Mika_Resume-d376ca66f1e54f1fa91ad972e170d8dc.pdf";